import { useFetcher } from '@remix-run/react'
import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { VisibilityStepsContext } from '~/contexts'
import { makeShopOwnPath } from '~/helpers/routes'
import { useShop } from '~/hooks/data/use-shop'
import { Button, Dialog } from '~/ui'

export const VisibilityConfirmationModal = () => {
  const shop = useShop()
  const { submit, state } = useFetcher()

  let { t } = useTranslation()
  const [{ isOpen, step, callback }, setContext] = useContext(
    VisibilityStepsContext
  )

  const onProceed = async () => {
    submit(
      { _intent: 'unpublishShop' },
      {
        method: 'post',
        action: makeShopOwnPath(shop, '/settings/general'),
      }
    )
  }

  useEffect(() => {
    if (isOpen && state === 'loading') {
      callback?.()
      setContext((prev) => ({ ...prev, isOpen: false }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, isOpen])

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open: boolean) =>
        setContext((oldState) => ({ ...oldState, isOpen: open }))
      }
    >
      <Dialog.Content>
        <Dialog.Title>
          {t(`page.settings.visibility.removal_confirmation.remove_${step}`)}
        </Dialog.Title>
        <div className="p-3">
          <p className="text-foreground/64 mb-5 max-w-[400px] text-xs font-medium">
            {t(
              `page.settings.visibility.removal_confirmation.${
                step === 'unpublish' ? 'unpublish_description' : 'description'
              }`
            )}
          </p>

          <div className="flex gap-3">
            <Button
              type="submit"
              onClick={() => onProceed()}
              isLoading={state != 'idle'}
              className="bg-destructive hover:bg-destructive"
            >
              {t('action.unpublish_store')}
            </Button>

            <Button
              type="submit"
              variant="ghost"
              onClick={() => setContext({ isOpen: false })}
            >
              {t('action.cancel')}
            </Button>
          </div>
        </div>
      </Dialog.Content>
    </Dialog>
  )
}
